'use strict';

var address = require('./checkout/address'),
	dialog = require('../dialog'),
	progress = require('../progress'),
	formPrepare = require('./checkout/formPrepare'),
	loqate = require('.././loqate');

var giftGuideSelectRequired = function () {
	var $continue = $('[name$="_save"]'),
		$guideCheckboxes = $('[name^="CatalogRequest"]');

	if ($guideCheckboxes.filter(':checked').length > 0) {
		$continue.prop('disabled', false);
	} else {
		$continue.prop('disabled', true);
	}
};
var giftguide = {
	init: function () {
		if ($('#CatalogRequestForm').length > 0) {
			var form = $('#CatalogRequestForm'),
				phoneNumber = form.find('input[name$="_mobilephone"]');

			giftGuideSelectRequired();
			$('[name^="CatalogRequest"]').on('change', giftGuideSelectRequired);

			// update states
			address.dynamicAddressFieldsHandler(form);
			form.find('select').uniform();

			if (typeof window.imagesLoaded !== 'undefined') {
				// eslint-disable-next-line no-undef
				imagesLoaded('.gift-guide-tile').on('done', function () {
					$('.gift-guide-tile').syncHeight()
						.each(function (idx) {
							$(this).data('idx', idx);
						});
				});
			}

			$(window).smartresize(function () {
				$('.gift-guide-tile').css('height', 'auto');
				$('.gift-guide-tile').syncHeight();
			});

			$('input[name$="_contactPreferencesAllowSMS"]').change(function () {
				var placeHolderValue = phoneNumber.attr('placeholder');
				if ($(this)[0].checked) {
					phoneNumber.attr('placeholder', placeHolderValue + '*')
						.removeClass('valid').addClass('required');
				} else if (phoneNumber.hasClass('required')) {
					phoneNumber.attr('placeholder', placeHolderValue.slice(0, placeHolderValue.length - 1))
						.removeClass('required error').addClass('valid')
						.closest('.form-row').find('.error-msg').css('display', 'none');
				}
			});
			formPrepare.init({
				continueSelector: '[name$="editAddress_save"]',
				formSelector: '#CatalogRequestForm',
				replaceInvalidInput: true,
				keyup: false,
				autofillValidate: true
			});

		}
		$('.gift-guide-tile-wrapper').on('click', '.quickview', function (e) {
			e.preventDefault();
			var id = '#' + $(this).attr('href');
			dialog.open({
				html: $(id).html(),
				options: {
					dialogClass: 'no-title catalogue-popup',
					height:400
				}
			});
		});
		$('.catalogue-request-submit-btn').on('click', function () {
			if ($('#CatalogRequestForm').valid()) {
				progress.show($('#CatalogRequestForm'), 'loader-alt');
				setTimeout(7000, progress.hide);
			}
		});
		loqate.init($('#CatalogRequestForm'));
	}
};
module.exports = giftguide;
